import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../buildStore';
import { getIsPublishingBlocked } from '../../selectors/getIsPublishingBlocked';
import { getTypingMessageShouldDisableUserInput } from '../../typing-indicators/selectors/getTypingMessageShouldDisableUserInput';
import { getIsBlockedByUnansweredQuickReply } from '../../thread-histories/selectors/getIsBlockedByUnansweredQuickReply';
import { getVisitorCanSendMessage } from '../../availability/selectors/getVisitorCanSendMessage';
import { trackComposerDisabled } from '../utils/trackMetric';
const SETTLING_THRESHOLD_MS = 7000;
function getDisabledReason(isPublishingBlocked, canSendMessage, isTypingDisabled, isQuickReplyBlocked) {
  if (isPublishingBlocked) return 'publishing';
  if (!canSendMessage) return 'availability';
  if (isTypingDisabled) return 'typing-indicator';
  if (isQuickReplyBlocked) return 'quick-reply';
  return 'unknown';
}
export function useTrackComposerDisabledMetric(surface, isInputDisabled, enabled = true) {
  const isPublishingBlocked = useAppSelector(getIsPublishingBlocked);
  const isTypingDisabled = useAppSelector(getTypingMessageShouldDisableUserInput);
  const isQuickReplyBlocked = useAppSelector(getIsBlockedByUnansweredQuickReply);
  const canSendMessage = useAppSelector(getVisitorCanSendMessage);
  const reasonRef = useRef('unknown');
  reasonRef.current = getDisabledReason(isPublishingBlocked, canSendMessage, isTypingDisabled, isQuickReplyBlocked);
  useEffect(() => {
    if (!isInputDisabled || !enabled) return;
    const timer = setTimeout(() => {
      trackComposerDisabled(reasonRef.current, surface);
    }, SETTLING_THRESHOLD_MS);
    return () => clearTimeout(timer);
  }, [isInputDisabled, enabled, surface]);
}